var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("modal-component", {
    staticClass: "lightbox-autorenewal",
    attrs: {
      id: "autorenewalModal",
      shown: _vm.shown,
      "handle-cancel": _vm.handleCancel,
    },
    scopedSlots: _vm._u(
      [
        _vm.currentPromotion
          ? {
              key: "header",
              fn: function () {
                return [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.autorenewalIsActive
                          ? _vm.i18n.deactivateAutorenewal
                          : _vm.i18n.activateAutorenewal
                      ) +
                      "\n    "
                  ),
                ]
              },
              proxy: true,
            }
          : null,
        _vm.currentPromotion
          ? {
              key: "body",
              fn: function () {
                return [
                  _vm.autorenewalIsActive
                    ? [
                        _c("p", [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.i18n.areYouSure) +
                              " "
                          ),
                          _c("strong", [
                            _vm._v(_vm._s(_vm.i18n.autorenewalWillBeCanceled)),
                          ]),
                          _vm._v(
                            " " +
                              _vm._s(_vm.i18n.autorenewalWillBeReactivated) +
                              "\n            "
                          ),
                        ]),
                      ]
                    : [
                        _c("p", [
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(_vm.i18n.modalDescription),
                            },
                          }),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(" "),
                          _c("strong", [_vm._v(_vm._s(_vm.i18n.doYouAgree))]),
                        ]),
                      ],
                ]
              },
              proxy: true,
            }
          : null,
        _vm.currentPromotion
          ? {
              key: "footer",
              fn: function () {
                return [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-primary btn-block",
                      attrs: { type: "button" },
                      on: { click: _vm.handleCancel },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.i18n.cancel) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary btn-block",
                      attrs: { type: "button" },
                      on: { click: _vm.handleConfirm },
                    },
                    [
                      _vm._v(
                        "\n            " + _vm._s(_vm.i18n.ok) + "\n        "
                      ),
                    ]
                  ),
                ]
              },
              proxy: true,
            }
          : null,
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }